import { render, staticRenderFns } from "./ListViewBase.vue?vue&type=template&id=a08a9642"
import script from "./ListViewBase.vue?vue&type=script&lang=js"
export * from "./ListViewBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports